module.exports = __webpack_public_path__ + "img/GLD.c2b8da5f.svg";